import React, { Component } from "react";

import Success from "./components/Success";
class SuccessPage extends Component {
  render() {
    return (
        <Success history={this.props.history} match={this.props.match} />
    );
  }
}

export default SuccessPage;
